// eslint-disable-next-line camelcase
import { jwtDecode } from 'jwt-decode';

const checkExpire = (expire) => (!(!expire || expire < parseInt(Date.now() / 1E3, 10)));

const isTokenValid = (token) => {
  try {
    const { exp } = jwtDecode(token);

    return checkExpire(exp);
  } catch (e) {
    return false;
  }
};

export default isTokenValid;
